import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { extendObservable } from 'mobx'
import { miscApi } from '@atheneum/api'

class StandardConditions extends Component {
  constructor (props) {
    super(props)
    extendObservable(this, { conditions: '' })
    miscApi.getStandardConditions().then(res => {
      this.conditions = res.value
    })
  }

  render () {
    return (
      <div style={{ padding: 25 }}>
        <h1>Standard Conditions</h1>
        <div dangerouslySetInnerHTML={{ __html: this.conditions }} />
      </div>
    )
  }
}

export default observer(StandardConditions)
